var map = {
	"./ar.json": [
		2053,
		2053
	],
	"./en.json": [
		27581,
		27581
	],
	"./id.json": [
		13355,
		13355
	],
	"./km.json": [
		42822,
		42822
	],
	"./th.json": [
		21918,
		21918
	],
	"./vi.json": [
		77031,
		77031
	],
	"./zh.json": [
		69804,
		69804
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3800;
module.exports = webpackAsyncContext;